import React from 'react';
import { AffiliateLink } from '../types';

interface AffiliateCardProps {
  affiliate: AffiliateLink;
}

const providerColors = {
  o2: 'border-blue-500 bg-blue-50',
  vodafone: 'border-red-500 bg-red-50',
  telekom: 'border-pink-500 bg-pink-50',
  congstar: 'border-yellow-500 bg-yellow-50',
  blau: 'border-blue-400 bg-blue-50'
};

const providerLogos = {
  o2: 'https://images.pexels.com/photos/o2-logo.png',
  vodafone: 'https://images.pexels.com/photos/vodafone-logo.png',
  telekom: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Telekom_Logo_2013.svg/1024px-Telekom_Logo_2013.svg.png',
  congstar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Congstar_logo.svg/1024px-Congstar_logo.svg.png',
  blau: 'https://www.blau.de/static/images/blau-logo.svg'
};

const AffiliateCard: React.FC<AffiliateCardProps> = ({ affiliate }) => {
  const { provider, url, dealText } = affiliate;
  const colorClass = providerColors[provider] || 'border-gray-300 bg-gray-50';
  
  return (
    <div className={`border-2 rounded-lg p-4 ${colorClass} transition-transform hover:-translate-y-1`}>
      <div className="flex items-center mb-3">
        {provider === 'o2' && (
          <svg className="h-8 w-8 mr-3 text-blue-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12a4 4 0 108 0 4 4 0 00-8 0z" />
          </svg>
        )}
        {provider === 'vodafone' && (
          <svg className="h-8 w-8 mr-3 text-red-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
          </svg>
        )}
        {provider === 'blau' && (
          <svg className="h-8 w-8 mr-3 text-blue-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect width="18" height="18" x="3" y="3" rx="2" />
          </svg>
        )}
        {(provider === 'telekom' || provider === 'congstar') && (
          <img src={providerLogos[provider]} alt={provider} className="h-8 mr-3" />
        )}
        <h4 className="font-semibold text-gray-800 capitalize">{provider}</h4>
      </div>
      
      {dealText && (
        <p className="text-sm text-gray-600 mb-4">{dealText}</p>
      )}
      
      <a 
        href={url} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="block w-full text-center py-2 px-4 bg-white text-gray-800 border border-gray-300 rounded-md font-medium hover:bg-gray-100 transition-colors"
      >
        Zum Angebot
      </a>
    </div>
  );
};

export default AffiliateCard;